/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pll_In_Reason_From_Agent_ReturnInputs */

const vi_pll_in_reason_from_agent_return = /** @type {(inputs: Pll_In_Reason_From_Agent_ReturnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đại lý đổi trả`)
};

/**

* @param {Pll_In_Reason_From_Agent_ReturnInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pll_in_reason_from_agent_return = /** @type {((inputs?: Pll_In_Reason_From_Agent_ReturnInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pll_In_Reason_From_Agent_ReturnInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pll_in_reason_from_agent_return(inputs)
});